import { render } from "./InternalUser.vue?vue&type=template&id=012b8513&scoped=true"
import script from "./InternalUser.vue?vue&type=script&lang=js"
export * from "./InternalUser.vue?vue&type=script&lang=js"

import "./InternalUser.vue?vue&type=style&index=0&id=012b8513&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012b8513"]])

export default __exports__